export const ClientServicesLink = () => (
  <a href='mailto:clientservices@myipo.com' target='_top'>
    clientservices@myipo.com
  </a>
);
